import { VueExtension } from "../../utils/extensions/vue";
import Loading from './loading.jsx'
import './loading.scss'

VueExtension.WithInstall(Loading)

export default Loading